import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UpdatePasswordStateService } from './state/update-password.state-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthLayoutComponent } from '../layout/auth-layout.component';
import { ButtonComponent } from '@design-system/buttons/button/button.component';
import { H3Component } from '@design-system/typography/h3/h3.component';
import { OnScreenMessagingService } from '@pattern-library/onscreen-messaging/onscreen-messaging.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatError } from '@angular/material/form-field';
import { PasswordInputComponent } from '@design-system/forms/password-input/password-input.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@UntilDestroy()
@Component({
  selector: 'app-update-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthLayoutComponent,
    ButtonComponent,
    H3Component,
    MatError,
    PasswordInputComponent,
    TestIdDirective
  ],
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
  providers: [UpdatePasswordStateService]
})
export class UpdatePasswordComponent implements OnInit {
  @Output() passwordUpdated = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  constructor(
    public stateService: UpdatePasswordStateService,
    private messaging: OnScreenMessagingService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  /** Path is `forgotten-password/:linkTypeId/:linkId` as in the password-reset email. */
  ngOnInit() {
    const linkTypeId = this.route.snapshot.paramMap.get('linkTypeId')?.trim();
    const linkId = this.route.snapshot.paramMap.get('linkId')?.trim();
    if (!linkTypeId || !linkId) {
      this.messaging.warn('Invalid password reset link');
      this.return();
      return;
    }

    this.stateService.setLinkParams(linkTypeId, linkId);
    this.stateService.setUpForm();
  }

  onSubmit() {
    if (this.stateService.formValid()) {
      this.stateService.persist$()
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.messaging.success('Password updated successfully');
            this.return();
          }
        });
    }
  }

  cancel() {
    this.return();
  }

  private return() {
    this.router.navigate(['/auth', { outlets: { top: ['sign-in'] } }]);
  }
} 